<div class="container">
  <div class="row">
    <ng-container *ngFor="let day of days">
      <div class="col-lg-6 col-md-12 pl-3 pt-5 pr-3">

        <div class="overview-box">
          <!-- <div class="row">
            <div class="col-12 text-secondary text-uppercase">
              <span class="text-08em">{{day.date | localizedDate: "MMM dd, yyyy"}}</span>
            </div>
          </div> -->

          <div class="row">
            <div class="col-12 text-capitalize">
              <span class="text-13em">{{ day.date | localizedDate: "EEEE dd MMMM" }}</span>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <hr class="line-green">
            </div>
          </div>

          <ng-container *ngIf="day.transferCity && day.cityBeforeServiceOrder?.length">
            <div class="row app-recap-city">
              <div class="col-12 pl-4 pt-2">
                <span class="overview-icons">
                  <app-service-icon [icon]="'globe-africa'" [customPath]="getServiceIconPath('globe-africa')"></app-service-icon>
                </span>
                <span class="text-capitalize">{{ day.transferCity | lowercase }}</span>
              </div>
            </div>
            <ng-container *ngFor="let serviceType of day.cityBeforeServiceOrder">
              <ng-container [ngSwitch]="serviceType.type">
                <app-recap-transfers *ngSwitchCase="'transfer'" [day]="getSingleServiceDay(day, serviceType.type, serviceType.index, true)" [serviceIcons]="serviceIcons"></app-recap-transfers>
                <app-recap-optional *ngSwitchCase="'optional'" [day]="getSingleServiceDay(day, serviceType.type, serviceType.index, true)" [serviceIcons]="serviceIcons" [version]="version"></app-recap-optional>
              </ng-container>
            </ng-container>
            <div class="row">
              <div class="col-12">
                <hr class="line-green mb-1 mx-2">
              </div>
            </div>
          </ng-container>


          <app-recap-escorteds [day]="day" [serviceIcons]="serviceIcons"></app-recap-escorteds>

          <app-recap-city [day]="day" *ngIf="!isCityAlreadyShownInEscorted(day)" [serviceIcons]="serviceIcons"></app-recap-city>

          <ng-container *ngFor="let serviceType of day.serviceOrder">
            <ng-container [ngSwitch]="serviceType.type">
              <app-recap-flights *ngSwitchCase="'flight'" [day]="getSingleServiceDay(day, serviceType.type, serviceType.index)" [serviceIcons]="serviceIcons"></app-recap-flights>
              <app-recap-vehicles *ngSwitchCase="'vehicle'" [day]="getSingleServiceDay(day, serviceType.type, serviceType.index)" [serviceIcons]="serviceIcons"></app-recap-vehicles>
              <app-recap-transfers *ngSwitchCase="'transfer'" [day]="getSingleServiceDay(day, serviceType.type, serviceType.index)" [serviceIcons]="serviceIcons"></app-recap-transfers>
              <app-recap-hotels *ngSwitchCase="'hotel'" [day]="getSingleServiceDay(day, serviceType.type, serviceType.index)" [serviceIcons]="serviceIcons"></app-recap-hotels>
              <app-recap-optional *ngSwitchCase="'optional'" [day]="getSingleServiceDay(day, serviceType.type, serviceType.index)" [serviceIcons]="serviceIcons" [version]="version"></app-recap-optional>
            </ng-container>
          </ng-container>
        </div>

      </div>
    </ng-container>
  </div>
</div>